<script setup lang="ts">
  import { NeedHelpPopup, NeedHelpButton } from '@/shared/components/rebranding/NeedHelp'
  import { ref } from 'vue'

  const showPopup = ref(false)

  const togglePopup = () => (showPopup.value = !showPopup.value)
</script>

<template>
  <NeedHelpButton @click="togglePopup" />
  <NeedHelpPopup v-if="showPopup" @close="togglePopup" />
</template>
